var _module_exports = "<span>Password was updated.</span>";;
var path = 'views/flashes/password_updated.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;